import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { CheckoutHeadline } from "../../checkout-page-layout/CheckoutComponent/shared/CheckoutHeadline";
import { css } from "@emotion/react";
import { SwishQrCode } from "./swish-qr-code";
import React from "react";
import { useInterval } from "../../../../hooks/use-interval";
import { FONTS, fontSize } from "../../../../styles/fonts";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../../components/T";

export const MakeSwishPayment: ReactTFC<{
  translations: { paragraph: TranslatedValue; openInApp: TranslatedValue };
  code: string;
  url: string;
  onRefreshRequested: () => void;
}> = props => {
  useInterval(true, 2500, props.onRefreshRequested);

  return (
    <>
      <div>
        <CheckoutHeadline
          css={css`
            margin-top: 0;
          `}
        >
          Swish
        </CheckoutHeadline>

        <p
          css={[
            FONTS.SwarovskiFutura300,
            fontSize.x3,
            css`
              display: block;
              text-align: center;
              margin-bottom: 12px;
            `,
          ]}
        >
          <T>{props.translations.paragraph}</T>
        </p>
      </div>

      <SwishQrCode
        code={props.code}
        url={props.url}
        translations={{
          openInApp: <T>{props.translations.openInApp}</T>,
        }}
      />
    </>
  );
};
